import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

// Debug: log API URL at startup
console.log('[API] Base URL:', API_URL)

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 120 second timeout (chat/RAG can be slower)
})

// Add auth token and workspace ID to requests
api.interceptors.request.use((config) => {
  console.log('[API] Request:', config.method?.toUpperCase(), config.url)
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  // Add workspace ID header for workspace isolation
  const workspaceId = localStorage.getItem('currentWorkspaceId')
  if (workspaceId) {
    config.headers['X-Workspace-Id'] = workspaceId
  }
  
  return config
})

// Handle auth errors
api.interceptors.response.use(
  (response) => {
    console.log('[API] Response:', response.status, response.config.url)
    return response
  },
  (error) => {
    console.error('[API] Error:', error.message, error.config?.url)
    if (error.response) {
      console.error('[API] Error response:', error.response.status, error.response.data)
    }
    if (error.response?.status === 401) {
      const errorMsg = error.response?.data?.error || ''
      console.warn('[API] 401 - Token invalido o scaduto:', errorMsg)
      // Don't redirect if already on login page to prevent loops
      if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/reset-password')) {
        localStorage.removeItem('access_token')
        // Small delay to let user see error before redirect
        setTimeout(() => {
          window.location.href = '/login'
        }, 100)
      }
    }
    return Promise.reject(error)
  }
)

export default api
